const localKey = {
  AUTH_TOKEN: 'authTOken',
  USER_ID: 'userId',
  IS_PIN_SET:'isPinSet',
  USER_DATA: 'userData',
  IS_USER_PARENT: 'isUserParent',
  TEMP_AUTH_TOKEN: 'tempAuthTOken',
};

export default localKey;
